export default __webpack_public_path__ + "static/media/vscode.19edc3fb.png";